import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { injectIntl, intlShape } from 'react-intl';
import { array, func } from 'prop-types';
import { getUtlParams, isMaster, getSlaveId } from '../statisticsHelpers';
import countrySelector from '../../../selectors/countries';
import { getStringOrSingleArrayValue } from '../../../utils/utils';

import { StatisticsFiltersView } from '../index';
import { startSetMyOffers } from '../../../actions/webmaster';
import { startSetStreams } from '../../../actions/streams';
import {
  startSetSlaves,
  startSetSlaveOffers,
  startSetSlaveOffersMulti,
  startSetSlaveStreams,
  startSetSlaveStreamsMulti,
  startSetSlaveSites,
  startSetCategories,
} from '../../../actions/slaves';

import { startSetSites } from '../../../actions/sites';

const normalizeData = (data = [], skipParent = false) => {
  const result = [];

  if (typeof data === 'string') {
    data = data.split(',').map(Number);
  }

  if (data.length > 0) {
    for (let i = 0; i < data.length; i++) {
      const item = data[i];

      if (item.subParams && item.subParams.length > 0) {
        result.push(...normalizeData(item.subParams));

        if (skipParent) {
          return;
        }
      }

      item.checked > 0 && result.push(item.id);
    }
  }

  return result;
};

class StatisticsFilters extends Component {
  static propTypes = {
    categories: array.isRequired,
    offers: array.isRequired,
    sources: array.isRequired,
    flows: array.isRequired,
    countries: array.isRequired,
    onFilterUpdate: func.isRequired,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    categories: [],
    offers: [],
    sources: [],
    countries: [],
    flows: [],
    onFilterUpdate() {},
  };

  constructor(props) {
    super(props);
    const { type, dateFrom, dateTo, ...filters } = props.filters;

    const dFrom = dateFrom ? moment(dateFrom, 'DD.MM.YYYY') : moment().subtract(6, 'd');

    const dTo = dateTo ? moment(dateTo, 'DD.MM.YYYY') : moment();
    this.state = {
      filters: {
        dateFrom: dFrom,
        dateTo: dTo,
        ...filters,
      },
      preset: 'default',
      subsDisabled: this.blockSubsIfDaysMax(dFrom),
      key: 'init',
      windowWidth: 0,
      collapse: false,
    };
  }

  componentDidMount() {
    this.getCategoriesOptions();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { dateFrom: nextFrom, dateTo: nextTo } = nextProps.filters;
    const { dateFrom: prevFrom, dateTo: prevTo, categories } = this.props.filters;
    if ([prevFrom, nextFrom, prevTo, nextTo].every((date) => date && moment.isMoment(date))) {
      const dFrom = moment(prevFrom).isSame(nextFrom);
      const dTo = moment(prevTo).isSame(nextTo);
      if (!dFrom || !dTo) {
        this.setState(() => ({ subsDisabled: this.blockSubsIfDaysMax(nextFrom) }));
      }
    } else {
      const dFrom = moment(prevFrom, 'DD.MM.YYYY').isSame(moment(nextFrom, 'DD.MM.YYYY'));
      const dTo = moment(prevTo, 'DD.MM.YYYY').isSame(moment(nextTo, 'DD.MM.YYYY'));
      if (!dFrom || !dTo) {
        this.setState(() => ({ subsDisabled: this.blockSubsIfDaysMax(nextFrom) }));
      }
    }
    const { filters } = this.state;
    this.setState(
      () => ({
        filters: {
          ...filters,
          categories: categories
        }
      })
    );

    // пока не понял, зачем этот кусок кода
    // const keys = Object.keys(nextProps.filters);
    // if (keys.length === 1 && keys.length !== Object.keys(this.props.filters).length) {
    //   this.resetFilters(nextProps);
    // }
  }

  resetFilters = (props) => {
    const dFrom = moment().subtract(6, 'd');
    const dTo = moment();
    this.setState(
      () => ({
        filters: {
          dateFrom: dFrom,
          dateTo: dTo,
          ...props.filters,
        },
        preset: 'default',
        key: Object.keys(props.filters).toString(),
      }),
      () => {
        this.props.onFilterUpdate(this.state.filters);
      },
    );
  };

  blockSubsIfDaysMax = (dateFrom) => {
    const currentDate = moment(moment(), 'DD.MM.YYYY');
    if (moment.isMoment(dateFrom) && moment.isMoment(currentDate)) {
      return currentDate.diff(dateFrom, 'days') > 90;
    } else {
      return currentDate.diff(moment(dateFrom, 'DD.MM.YYYY'), 'days') > 90;
    }
  };

  onCategoriesChange = (categories) => {
    let checked = normalizeData(categories);

    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        categories: checked,
      },
    }));
  };

  onCategoriesReset = (categories) => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          categories: [],
        },
      }),
      () => this.props.onFilterUpdate(this.state.filters)
    );
  };

  onTimezoneChange = (timeZone) => {
    let filters = null;
    this.setState(
      (prevState) => {
        filters = { ...prevState.filters, ...timeZone };
        return { filters };
      },
      () => {
        this.props.onFilterUpdate(filters);
      },
    );
  };

  onSourceChange = (sources) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        sources: sources.map(({ value }) => value),
      },
    }));
  };

  onOfferChange = (offers) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        offers: offers.map(({ value }) => value),
      },
    }));
  };

  onCountryChange = (countries) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        countries: countries.map(({ value }) => value),
      },
    }));
  };

  onFlowChange = (flows) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        flows: flows.map(({ value }) => value),
      },
    }));
  };

  onStatusChange = (statuses) => {
    const statusGroups = {
      native: [0, 1, 2, 3],
      transferred: [10],
    };

    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        statuses: statuses.reduce(
          (result, { value }) => [...result, ...(statusGroups[value] || [])],
          [],
        ),
      },
    }));
  };

  onBuyersChange = (buyers) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        buyers: buyers.map(({ value }) => value),
      },
    }));
  };

  onDateChange = (startDate = {}, endDate = {}) => {
    if (moment.isMoment(startDate) && moment.isMoment(endDate)) {
      this.setState((prevState) => ({
        filters: {
          ...prevState.filters,
          dateFrom: startDate,
          dateTo: endDate,
        },
      }));
    }
  };

  onSubIdsChange = (subIds, cb = () => {}) => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          ...subIds,
        },
      }),
      () => {
        cb();
      },
    );
  };

  onSelectPreset = (filters = {}, presetId) => {
    this.setState(
      (prevState) => ({
        preset: presetId,
        filters: {
          dateFrom: prevState.filters.dateFrom,
          dateTo: prevState.filters.dateTo,
          buyers: prevState.filters.buyers,
          ...filters,
        },
        subsDisabled: this.blockSubsIfDaysMax(prevState.filters.dateFrom),
      }),
      () => {
        this.filterApplyHandler();
      },
    );
  };

  onRemovePreset = (id) => {
    const message = this.props.intl.formatMessage({
      id: 'statistics.preset.removed',
      defaultMessage: 'Preset Removed',
    });

    this.props
      .onRemovePreset(id)
      .then(() => this.onSelectPreset({}, 'default'))
      .then(() => this.showAlert(message));
  };

  onSavePreset = (id, title) => {
    const message = this.props.intl.formatMessage({
      id: 'statistics.preset.saved',
      defaultMessage: 'Preset Saved',
    });

    const {
      categories,
      countries,
      flows,
      statuses,
      offers,
      sites,
      sources,
      subId1,
      subId2,
      subId3,
      subId4,
      subId5,
    } = this.state.filters;

    const filter = {
      categories,
      countries,
      flows,
      statuses,
      offers,
      sites,
      sources,
      subId1,
      subId2,
      subId3,
      subId4,
      subId5,
    };

    if (!id) {
      this.props
        .onCreatePreset({ title, filter: JSON.stringify(filter) })
        .then((result) => result.preset)
        .then((preset = {}) => {
          if (preset.id) {
            this.setState(() => ({ preset: preset.id }));
            this.showAlert(message);
          }
        });
    } else {
      this.props
        .onSavePreset(id, { title, filter: JSON.stringify(filter) })
        .then((result) => result.id)
        .then((id) => {
          if (id) {
            this.setState(() => ({ preset: id }));
            this.showAlert(message);
          }
        });
    }
  };

  showAlert = (message, params) => {
    this.props.showAlert({
      alertType: 'success',
      dismissable: false,
      closeInSeconds: 3,
      message,
      ...params,
    });
  };

  setItemStatus = (items, selectedItems) => {
    if (typeof selectedItems === 'string') {
      selectedItems = selectedItems.split(',').map(Number);
    }

    return items.map((item) => {
      return {
        ...item,
        checked: selectedItems ? selectedItems.includes(item.id) : false,
        subParams: item.subParams ? this.setItemStatus(item.subParams, selectedItems) : [],
      };
    });
  };

  filterApplyHandler = () => {
    this.props.onFilterUpdate(this.state.filters);
    this.setState((prevState) => {
      return { key: Object.keys(prevState.filters).toString() };
    });
  };

  filterClearHandler = (name, cb = () => {}) => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          [name]: [],
        },
      }),
      () => {
        cb();
        this.props.onFilterUpdate(this.state.filters);
      },
    );
  };

  getLabel = (label) => {
    const key = label.toLowerCase();
    const { filters } = this.state;
    const { intl } = this.props;
    const translated = intl.formatMessage({
      id: `statistics.filters.${key}`,
      defaultMessage: label,
    });

    if (key === 'statuses' && filters.statuses) {
      const statuses = Array.isArray(filters.statuses)
        ? filters.statuses.map(Number)
        : String(filters.statuses)
            .split(',')
            .filter(Boolean)
            .map(Number);
      const selectedGroupsCount =
        Number(statuses.some((status) => status !== 10)) + Number(statuses.includes(10));

      return selectedGroupsCount > 0 ? `${translated} (${selectedGroupsCount})` : translated;
    }

    if (filters[key]) {
      if (typeof filters[key] === 'string' && filters[key].split(',').length > 0)
        return `${translated} (${filters[key].split(',').length})`;
      if (Object.keys(filters[key]).length > 0)
        return `${translated} (${Object.keys(filters[key]).length})`;
    }
    return `${translated}`;
  };

  getSubIdsLabel = (label) => {
    return label;
  };

  getChangingFilterOptions = (type) => {
    return this.props[type].map((item) => {
      return {
        value: item.id,
        label: item.title,
      };
    });
  };

  updateWindowDimensions = () => {
    this.setState(() => ({ windowWidth: window.innerWidth }));
  };

  toggleCollapse = () => {
    this.setState((prevState) => ({
      collapse: !prevState.collapse,
    }));
  };

  getOffersOptions = () => {
    const { isMember, isMembers, startSetMyOffers, startSetSlaveOffers, startSetSlaveOffersMulti, slavesList } = this.props;

    if (isMembers && slavesList && slavesList.length > 0) {
      return startSetSlaveOffersMulti(slavesList.map(({ id }) => id), { limit: 0, short: 1 });
    }

    const params = !isMember ? { limit: 0, short: 1 } : { limit: 0, short: 1, id: getSlaveId() };
    const req = !isMember ? startSetMyOffers : startSetSlaveOffers;

    return req(params);
  };

  getCategoriesOptions = () => {
    const { startSetCategories } = this.props;

    return startSetCategories();
  };

  getStreamsOptions = () => {
    const { isMember, isMembers, startSetStreams, startSetSlaveStreams, startSetSlaveStreamsMulti, slavesList } = this.props;

    if (isMembers && slavesList && slavesList.length > 0) {
      return startSetSlaveStreamsMulti(slavesList.map(({ id }) => id), { limit: 1000, short: 1 });
    }

    const params = !isMember
      ? { limit: 1000, short: 1 }
      : { limit: 1000, short: 1, id: getSlaveId() };
    const req = !isMember ? startSetStreams : startSetSlaveStreams;

    return req(params);
  };

  getSitesOptions = () => {
    const { isMember, startSetSites, startSetSlaveSites } = this.props;

    const params = !isMember ? { limit: 0 } : { limit: 0, id: getSlaveId() };
    const req = !isMember ? startSetSites : startSetSlaveSites;

    return req(params);
  };

  render() {
    const { dateTo, dateFrom, timeZone } = this.state.filters;
    const { key } = this.state;
    const { isMembers, isAggregated, slavesList } = this.props;
    const data = { ...this.props, ...this.state, dateTo, dateFrom, timeZone, key };
    const { windowWidth, collapse } = this.state;
    // const isCollapsing = windowWidth < 768;
    const isCollapsing = false;
    const checkedItems = this.setItemStatus(this.props.categories, this.state.filters.categories);
    const buyersOptions = (slavesList || []).map(({ id: value, title: label }) => ({ value, label }));

    return (
      <StatisticsFiltersView
        data={data}
        onTimezoneChange={this.onTimezoneChange}
        onDateChange={this.onDateChange}
        filterApplyHandler={this.filterApplyHandler}
        onCategoriesChange={this.onCategoriesChange}
        onCategoriesReset={this.onCategoriesReset}
        onSourceChange={this.onSourceChange}
        filterClearHandler={this.filterClearHandler}
        onOfferChange={this.onOfferChange}
        onSubIdsChange={this.onSubIdsChange}
        subsDisabled={this.subsDisabled}
        onFlowChange={this.onFlowChange}
        onStatusChange={this.onStatusChange}
        onCountryChange={this.onCountryChange}
        onSelectPreset={this.onSelectPreset}
        onRemovePreset={this.onRemovePreset}
        onSavePreset={this.onSavePreset}
        getSubIdsLabel={this.getSubIdsLabel}
        getLabel={this.getLabel}
        getChangingFilterOptions={this.getChangingFilterOptions}
        getCategoriesOptions={this.getCategoriesOptions}
        categories={checkedItems}
        resetFilters={this.resetFilters}
        isCollapsing={isCollapsing}
        isMembers={isMembers}
        isAggregated={isAggregated}
        slavesList={slavesList}
        getSitesOptions={this.getSitesOptions}
        getOffersOptions={this.getOffersOptions}
        getStreamsOptions={this.getStreamsOptions}
        toggleCollapse={this.toggleCollapse}
        onBuyersChange={this.onBuyersChange}
        buyersOptions={buyersOptions}
      />
    );
  }
}

const mapStateToProps = ({ statistics, webmaster, streams, app, slaves }) => {
  const {
    parsedQuery: { timeZone: tz },
  } = getUtlParams();
  const timeZone = tz
    ? tz
    : statistics.filters.timeZone
    ? getStringOrSingleArrayValue(statistics.filters.timeZone)
    : webmaster.profile.timezone;
  const master = isMaster();
  return {
    countries: countrySelector(app.globalSettings.countries, { active: 1 }),
    offers: !master ? webmaster.offers : slaves.offers,
    categories: slaves.categories,
    flows: !master ? streams.streams : slaves.streams.streams,
    sources: !master ? webmaster.sites : slaves.slaveSites,
    slavesList: slaves.ids,
    filters: { ...statistics.filters, timeZone },
    presets: statistics.presets,
  };
};

const mapDispatchToProps = (dispatch) => ({
  startSetSlaves: () => dispatch(startSetSlaves()),
  startSetCategories: () => dispatch(startSetCategories()),

  // offers
  startSetMyOffers: (params) => dispatch(startSetMyOffers(params)),
  startSetSlaveOffers: (params) => dispatch(startSetSlaveOffers(params)),
  startSetSlaveOffersMulti: (ids, params) => dispatch(startSetSlaveOffersMulti(ids, params)),

  // streams
  startSetStreams: (params) => dispatch(startSetStreams(params)),
  startSetSlaveStreams: (params) => dispatch(startSetSlaveStreams(params)),
  startSetSlaveStreamsMulti: (ids, params) => dispatch(startSetSlaveStreamsMulti(ids, params)),

  // sites
  startSetSites: (params) => dispatch(startSetSites(params)),
  startSetSlaveSites: (params) => dispatch(startSetSlaveSites(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(StatisticsFilters));
